import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TextArea from "./../../../component/atoms/input/textarea";
import Radio from "./../../../component/atoms/input/radio";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import DateInput from "./../../../component/atoms/input/dateInput";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Table from "./../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import Modal from "../../../component/templates/Modal";

import { toastMsg } from "../../../util/toastMsg";
import scrollToTop from "../../../util/scrollToTop";
import { errorHandler } from "../../../util/errorHandler";
import { route } from "../../../router/route";

import SelectGroupBox from "./_components/selectGroupBox";
import { hourList, minuteList } from "../../../constants/timeArr";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import GroupApi from "../../../api/group.api";
import SmsApi from "../../../api/sms.api";
import moment from "moment";
import Empty from "../../../component/molecules/empty";

const OperationMessageSms = () => {
  const navigate = useNavigate();

  // ---------- 주의사항 관련 ---------- //
  const [cautionOpen, setCautionOpen] = useState(false);

  // ---------- 발신번호 관련 ---------- //
  const [phoneNumberIsCertified, setPhoneNumberIsCertified] = useState(true);

  // ---------- 발송 대상 관련 ---------- //
  const [sendType, setSendType] = useState("회원 그룹에게 발송");

  useEffect(() => {
    if (sendType === "번호 입력하여 발송") {
      setSelectedTarget("");
      setSelectedGroup(0);
    }
  }, [sendType]);

  const targetList = [
    {
      title: "전체회원",
      value: "전체회원",
    },
    {
      title: "지정그룹",
      value: "지정그룹",
    },
  ];
  const [selectedTarget, setSelectedTarget] = useState("");
  const [targetListBoxOpen, setTargetListBoxOpen] = useState(false);

  useEffect(() => {
    if (selectedTarget === "전체회원") {
      setSelectedGroup(0);
    }
  }, [selectedTarget]);

  const [groupList, setGroupList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [groupListBoxOpen, setGroupListBoxOpen] = useState(false);

  const [recentlyList, setRecentlyList] = useState([]);
  const [reservationList, setReservationList] = useState([]);

  useEffect(() => {
    getNormalGroupList();
    getSMSList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getSMSList = async () => {
    try {
      const data01 = {
        page: 1,
        size: 6,
        sendComplete: "Active",
      };

      const response01 = (await SmsApi.getList(data01)).data.data.content;
      setRecentlyList(response01);

      const data02 = {
        page: 1,
        size: 6,
        isNow: "Inactive",
      };
      const response02 = (await SmsApi.getList(data02)).data.data.content;
      setReservationList(response02);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 일반 그룹 가져오기
  const getNormalGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
      };

      const response = (await GroupApi.getList(data)).data.data.content;

      let groupTemp = response.map((item) => {
        return { title: item.title, value: item.id };
      });
      setGroupList(groupTemp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [smsContent, setSmsContent] = useState("");
  const [numberDivideArray, setNumberDivideArray] = useState([]);

  const [content, setContent] = useState("");

  useEffect(() => {
    if (smsContent.length > 0) {
      setNumberDivideArray(smsContent.split("\n"));
    }
  }, [smsContent]);

  // ---------- 발송 시간 관련 ---------- //
  const [selectedTime, setSelectedTime] = useState("지금");

  //예약날짜
  const [sendTimeValue, setSendTimeValue] = useState("");

  const [hourBoxOpen, setHourBoxOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState("");

  const [minuteBoxOpen, setMinuteBoxOpen] = useState(false);
  const [selectedMinute, setSelectedMinute] = useState("");

  // ---------- SMS 자동 메시지 설정 관련 ---------- //
  const [autoSendUse, setAutoSendUse] = useState(false);

  const autoSendGroupList = [
    { title: "운영 - 그룹1", value: "운영 - 그룹1" },
    { title: "운영 - 그룹2", value: "운영 - 그룹2" },
    { title: "운영 - 그룹3", value: "운영 - 그룹3" },
    { title: "운영 - 그룹4", value: "운영 - 그룹4" },
  ];

  const [autoSendSettingList, setAutoSendSettingList] = useState([
    {
      title: "가입완료",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "결제 완료 안내",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "취소 요청 접수",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "취소 완료",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "1:1 문의 등록",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "1:1 문의 답변",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
    {
      title: "후기 작성",
      member: true,
      owner: true,
      group: "",
      groupListBoxOpen: false,
    },
  ]);

  // ---------- 발송 & 저장하기 ---------- //
  const [createModalOpen, setCreateModalOpen] = useState({
    setting: false,
    autoSend: false,
  });

  function isNumericString(str) {
    const regex = /^\d+$/;
    return regex.test(str);
  }

  const createSMSFunc = async () => {
    try {
      if (sendType === "회원 그룹에게 발송") {
        if (selectedTarget === "") {
          return toast("발송대상을 선택해주세요.");
        }
      } else {
        if (smsContent === "") {
          return toast("받는이를 입력해주세요.");
        }

        if (!numberDivideArray.every((item) => isNumericString(String(item)))) {
          return toast("받는이는 숫자만 입력 가능합니다.");
        }
      }

      if (content === "") {
        return toast("알림 내용을 입력해주세요.");
      }

      if (selectedTime === "예약") {
        if (
          selectedHour === "" ||
          selectedMinute === "" ||
          sendTimeValue === ""
        ) {
          return toast("예약 날짜를 선택해주세요.");
        }

        const selectedTime = moment(
          `${sendTimeValue} ${selectedHour}:${selectedMinute}:00`,
          "YYYY-MM-DD HH:mm:ss"
        );
        const currentTime = moment();

        if (!selectedTime.isAfter(currentTime)) {
          toast("예약 시간은 현재 시간보다 이후여야 합니다.");

          return;
        }
      }

      const data = {
        content: content,
        isNow: selectedTime === "지금" ? true : false,
        sendDate:
          selectedTime === "지금"
            ? moment().format("YYYY-MM-DD HH:mm:ss")
            : `${sendTimeValue} ${selectedHour}:${selectedMinute}:00`,
        groupId: selectedGroup,
        phoneNumberList: numberDivideArray,
      };

      await SmsApi.createSms(data);

      setCreateModalOpen({
        setting: true,
        autoSend: false,
      });
      toast(toastMsg.create);
      scrollToTop();

      setSendType("회원 그룹에게 발송");
      setSelectedTarget("");
      setSelectedGroup(0);

      setContent("");
      setSmsContent("");

      setSelectedTime("지금");
      setSelectedHour("");
      setSelectedMinute("");
      setSendTimeValue("");

      await getSMSList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>메시지 보내기</TableTitle>
          <TabWrapper>
            <Tab
              isActive={false}
              onClick={() => {
                navigate(route.operation_message_alarm);
              }}
            >
              <TabText isActive={false}>알림</TabText>
            </Tab>
            <Tab
              isActive={false}
              onClick={() => {
                navigate(route.operation_message_email);
              }}
            >
              <TabText isActive={false}>이메일</TabText>
            </Tab>
            <Tab
              isActive={true}
              onClick={() => {
                navigate(route.operation_message_sms);
              }}
            >
              <TabText isActive={true}>SMS</TabText>
            </Tab>
          </TabWrapper>

          <MessageSmsContainer>
            <PretendardText
              style={{
                fontSize: 18,
                fontWeight: 700,
                lineHeight: "32.5px",
                letterSpacing: "-0.3%",
                color: "#f3f3f3",
                marginBottom: 12,
              }}
            >
              SMS 발송 설정
            </PretendardText>
            {/* 광고성 문자 메시지 전송 시 주의사항 */}
            <MessageSmsItemWrapper>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setCautionOpen(!cautionOpen);
                  }}
                >
                  <MessageSmsItemTitle
                    style={{
                      width: 192,
                      marginTop: 0,
                      color: "#009bde",
                    }}
                  >
                    광고성 문자메시지 전송시 주의사항
                  </MessageSmsItemTitle>
                  <img
                    className={cautionOpen ? "rotate" : "rotate-back"}
                    style={{
                      width: 18,
                      height: 18,
                      cursor: "pointer",
                    }}
                    src="/assets/admin/icons/ico_arrow_down_blue.svg"
                    onClick={() => {}}
                    alt=""
                  />
                </div>
                {cautionOpen && (
                  <MessageSmsItemContentText>
                    1. 전송시 (광고)를 메시지 시작되는 부분에 입력해 주세요.
                    (광/고), (광_고), (광,고) 와 같이 변칙 표기는 안됩니다.
                    <br />
                    2. 수신자가 어디에서 온 광고인지 인지 할수 있도록 전송자의
                    명칭(업체명)을 표시하여야 합니다.
                    <br />
                    3. 수신거부, 수신동의철회 할 수 있는 방식을 수신자가 비용을
                    부담하지 아니한다는 것과 함께 안내 하여야 합니다.
                    <br />
                    (수신거부시 14일 이내에 조치하고 처리 결과를 알려주어야
                    합니다.)
                    <br />
                    4. 수신자가 통신사의 스팸차단 서비스를 이용 중인 경우 광고성
                    문자가 전송되지 않을 수 있으나 도달 여부를 시스템에서 알 수
                    없기에 과금처리 됩니다.
                    <br />위 사항 위반시 3천만원 이하의 과태료가 부과될 수
                    있습니다.
                  </MessageSmsItemContentText>
                )}
              </div>
            </MessageSmsItemWrapper>

            {/* 발신번호 */}
            <MessageSmsItemWrapper>
              <MessageSmsItemTitle
                style={{
                  marginTop: phoneNumberIsCertified ? 3 : 0,
                }}
              >
                발신번호
              </MessageSmsItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 14,
                }}
              >
                {/* 발신번호 인증인 경우 */}
                {phoneNumberIsCertified && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <MessageSmsItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                      }}
                    >
                      01012345678
                    </MessageSmsItemTitle>
                    <MessageSmsItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                        color: "#009bde",
                      }}
                    >
                      인증완료
                    </MessageSmsItemTitle>
                    {/* <GrayBtn
                      onClick={() => {
                        setPhoneNumberIsCertified(false);
                      }}
                    >
                      발신번호 변경
                    </GrayBtn> */}
                  </div>
                )}

                {/* 발신번호 미인증인 경우 */}
                {!phoneNumberIsCertified && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <MessageSmsItemTitle
                        style={{
                          width: "fit-content",
                          marginTop: 0,
                          color: "#cf6679",
                        }}
                      >
                        미인증
                      </MessageSmsItemTitle>
                      <GrayBtn
                        onClick={() => {
                          setPhoneNumberIsCertified(true);
                        }}
                      >
                        발신번호 인증
                      </GrayBtn>
                    </div>
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "18.75px",
                        color: "#cf6679",
                      }}
                    >
                      전기통신사업법에 따라 유효한 번호로만 발신 가능하며, 인증
                      후 SMS 사용이 가능합니다
                    </PretendardText>
                  </>
                )}
              </div>
            </MessageSmsItemWrapper>

            {/* 발송 대상 */}
            <MessageSmsItemWrapper>
              <MessageSmsItemTitle
                style={{
                  marginTop: 0,
                }}
              >
                발송 대상
              </MessageSmsItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 30,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <Radio
                    id={""}
                    valueText={"회원 그룹에게 발송"}
                    checked={sendType === "회원 그룹에게 발송"}
                    onChange={() => {
                      setSendType("회원 그룹에게 발송");
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"번호 입력하여 발송"}
                    checked={sendType === "번호 입력하여 발송"}
                    onChange={() => {
                      setSendType("번호 입력하여 발송");
                    }}
                  />
                </div>
                {sendType === "회원 그룹에게 발송" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <SelectBoxValue
                      placeholder="발송대상을 선택해주세요"
                      selectedValue={selectedTarget}
                      isOpen={targetListBoxOpen}
                      wrapperHandler={() => {
                        setTargetListBoxOpen(!targetListBoxOpen);
                      }}
                      itemList={targetList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedTarget(value);
                      }}
                    />
                    {selectedTarget === "지정그룹" && (
                      <SelectBoxValue
                        placeholder="그룹을 선택해주세요"
                        selectedValue={selectedGroup}
                        isOpen={groupListBoxOpen}
                        wrapperHandler={() => {
                          setGroupListBoxOpen(!groupListBoxOpen);
                        }}
                        itemList={groupList}
                        selectedValueSetterFunc={(value) => {
                          setSelectedGroup(value);
                        }}
                      />
                    )}
                  </div>
                )}
                {sendType === "번호 입력하여 발송" && (
                  <TextArea
                    type={"text"}
                    placeholder={
                      "받는 이(전화번호), 여러명에게 전송시 엔터로 구분"
                    }
                    value={smsContent}
                    onChange={(e) => {
                      setSmsContent(e.target.value);
                    }}
                    style={{
                      width: "744px",
                      minHeight: "107px",
                    }}
                  />
                )}
              </div>
            </MessageSmsItemWrapper>

            {/* 보내실 내용 */}
            <MessageSmsItemWrapper>
              <MessageSmsItemTitle>보내실 내용</MessageSmsItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                <TextArea
                  type={"text"}
                  placeholder={"내용을 입력해주세요"}
                  value={content}
                  onChange={(e) => {
                    setContent(e.target.value);
                  }}
                  maxLength={90}
                  style={{
                    width: "572px",
                    minHeight: "107px",
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      lineHeight: "18.75px",
                      color: "rgba(181, 181, 181, 0.5)",
                    }}
                  >
                    {content.length}/50
                  </PretendardText>
                </div>
              </div>
            </MessageSmsItemWrapper>

            {/* 발송 시간 */}
            <MessageSmsItemWrapper>
              <MessageSmsItemTitle
                style={{
                  marginTop: 0,
                }}
              >
                발송 시간
              </MessageSmsItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 24,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 30,
                  }}
                >
                  <Radio
                    id={""}
                    valueText={"지금"}
                    checked={selectedTime === "지금"}
                    onChange={() => {
                      setSelectedTime("지금");
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"예약"}
                    checked={selectedTime === "예약"}
                    onChange={() => {
                      setSelectedTime("예약");
                    }}
                  />
                </div>
                {selectedTime === "예약" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "18.75px",
                        color: "#aaa",
                        marginBottom: 10,
                      }}
                    >
                      예약한 시간에 업로드 됩니다
                    </PretendardText>
                    <DateInput
                      value={sendTimeValue}
                      onChange={(e) => {
                        setSendTimeValue(e.target.value);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                        marginTop: 16,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBoxValue
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedHour}
                          isOpen={hourBoxOpen}
                          wrapperHandler={() => {
                            setHourBoxOpen(!hourBoxOpen);
                          }}
                          itemList={hourList}
                          selectedValueSetterFunc={setSelectedHour}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          시
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBoxValue
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedMinute}
                          isOpen={minuteBoxOpen}
                          wrapperHandler={() => {
                            setMinuteBoxOpen(!minuteBoxOpen);
                          }}
                          itemList={minuteList}
                          selectedValueSetterFunc={setSelectedMinute}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          분
                        </PretendardText>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </MessageSmsItemWrapper>
            <div
              style={{
                width: "100%",
                height: 79,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 12,
              }}
            >
              <BasicBtn
                onClick={() => {
                  createSMSFunc();
                }}
              >
                발송하기
              </BasicBtn>
            </div>

            {/* ********** 최근 30일 발송 SMS, 발송 예약 SMS ********** */}
            <div
              style={{
                height: "fit-content",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 26,
                margin: "70px 0px",
              }}
            >
              {/* 최근 30일 발송 SMS */}
              <SmsBoxContainer>
                <SmsBoxHeaderContainer>
                  <SmsBoxHeaderWrapper>
                    <SmsBoxHeaderTitle>최근 30일 발송 SMS</SmsBoxHeaderTitle>
                    <SmsBoxHeaderMore
                      onClick={() => {
                        navigate(`${route.operation_message_sms_detail}/send`);
                        scrollToTop();
                      }}
                    >
                      더보기
                    </SmsBoxHeaderMore>
                  </SmsBoxHeaderWrapper>
                </SmsBoxHeaderContainer>
                <SmsBoxContentContainer>
                  <div
                    style={{
                      width: "100%",
                      height: 354,
                    }}
                  >
                    {recentlyList.length > 0 ? (
                      recentlyList.map((item, index) => {
                        return (
                          <SmsBoxContentWrapper key={index}>
                            <SmsBoxContentText
                              className="truncate"
                              style={{
                                width: 254,
                              }}
                            >
                              {item.content}
                            </SmsBoxContentText>
                            <SmsBoxContentText>
                              {moment(item.sendDate).format("YYYY-MM-DD HH:mm")}
                            </SmsBoxContentText>
                          </SmsBoxContentWrapper>
                        );
                      })
                    ) : (
                      <Empty
                        style={{
                          width: "100%",
                          height: 354,
                        }}
                      />
                    )}
                  </div>
                </SmsBoxContentContainer>
              </SmsBoxContainer>

              {/* 발송 예약 SMS */}
              <SmsBoxContainer>
                <SmsBoxHeaderContainer>
                  <SmsBoxHeaderWrapper>
                    <SmsBoxHeaderTitle>발송 예약 SMS</SmsBoxHeaderTitle>
                    <SmsBoxHeaderMore
                      onClick={() => {
                        navigate(
                          `${route.operation_message_sms_detail}/reservation`
                        );
                        scrollToTop();
                      }}
                    >
                      더보기
                    </SmsBoxHeaderMore>
                  </SmsBoxHeaderWrapper>
                </SmsBoxHeaderContainer>
                <SmsBoxContentContainer>
                  <div
                    style={{
                      width: "100%",
                      height: 354,
                    }}
                  >
                    {reservationList.length > 0 ? (
                      reservationList.map((item, index) => {
                        return (
                          <SmsBoxContentWrapper key={index}>
                            <SmsBoxContentText
                              className="truncate"
                              style={{
                                width: 254,
                              }}
                            >
                              {item.content}
                            </SmsBoxContentText>
                            <SmsBoxContentText>
                              {moment(item.sendDate).format("YYYY-MM-DD HH:mm")}
                            </SmsBoxContentText>
                          </SmsBoxContentWrapper>
                        );
                      })
                    ) : (
                      <Empty
                        style={{
                          width: "100%",
                          height: 354,
                        }}
                      />
                    )}
                  </div>
                </SmsBoxContentContainer>
              </SmsBoxContainer>
            </div>

            {/* SMS 자동 메시지 설정 */}
            <PretendardText
              style={{
                fontSize: 18,
                fontWeight: 700,
                lineHeight: "32.5px",
                letterSpacing: "-0.3%",
                color: "#f3f3f3",
                marginBottom: 12,
              }}
            >
              SMS 자동 메시지 설정
            </PretendardText>
            <MessageSmsItemWrapper>
              <MessageSmsItemTitle
                style={{
                  marginTop: 0,
                }}
              >
                사용여부
              </MessageSmsItemTitle>
              <CheckboxWrapper
                onClick={() => {
                  setAutoSendUse(!autoSendUse);
                }}
              >
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={autoSendUse}
                  onChange={() => {}}
                />
                <CheckboxText>사용</CheckboxText>
              </CheckboxWrapper>
            </MessageSmsItemWrapper>

            {autoSendUse && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* <MessageSmsItemTitle
                  style={{
                    margin: "33px 0px 97px 0px",
                  }}
                >
                  소유자 수신번호
                </MessageSmsItemTitle> */}

                <Table>
                  <colgroup>
                    {/* 합계: 1044px */}
                    {/* 항목 */}
                    <col width="495px" />
                    {/* 회원 */}
                    <col width="87px" />
                    {/* 소유자 */}
                    <col width="160px" />
                    {/* 운영진 그룹 */}
                    <col width="302px" />
                  </colgroup>
                  <thead>
                    <Tr style={{ height: "41px", background: "#272829" }}>
                      <Th style={{ paddingLeft: "32px" }}>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          항목
                        </TableText>
                      </Th>
                      <Th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          회원
                        </TableText>
                      </Th>
                      <Th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          소유자
                        </TableText>
                      </Th>
                      <Th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          운영진 그룹
                        </TableText>
                      </Th>
                    </Tr>
                  </thead>
                  <tbody>
                    {autoSendSettingList.map((item, index) => {
                      return (
                        <Tr
                          key={index}
                          style={{
                            height: "59px",
                            padding: "20px 0px",
                            background: "transparent",
                            borderBottom:
                              "0.5px solid rgba(255, 255, 255, 0.12)",
                          }}
                        >
                          {/* 항목 */}
                          <Td style={{ paddingLeft: "32px" }}>
                            <TableText>{item.title}</TableText>
                          </Td>
                          {/* 회원 */}
                          <Td>
                            {item.title !== "후기 작성" && (
                              <Checkbox
                                style={{
                                  backgroundColor: "transparent",
                                }}
                                checked={item.member}
                                onChange={() => {
                                  autoSendSettingList[index].member =
                                    !item.member;
                                  setAutoSendSettingList([
                                    ...autoSendSettingList,
                                  ]);
                                }}
                              />
                            )}
                          </Td>
                          {/* 소유자 */}
                          <Td>
                            <Checkbox
                              style={{
                                backgroundColor: "transparent",
                              }}
                              checked={item.owner}
                              onChange={() => {
                                autoSendSettingList[index].owner = !item.owner;
                                setAutoSendSettingList([
                                  ...autoSendSettingList,
                                ]);
                              }}
                            />
                          </Td>
                          <Td>
                            <SelectGroupBox
                              placeholder={"그룹선택"}
                              selectedValues={item.group}
                              isOpen={item.groupListBoxOpen}
                              wrapperHandler={() => {
                                autoSendSettingList[index].groupListBoxOpen =
                                  !item.groupListBoxOpen;
                                setAutoSendSettingList([
                                  ...autoSendSettingList,
                                ]);
                              }}
                              itemList={autoSendGroupList}
                              selectedValueSetterFunc={(value) => {
                                autoSendSettingList[index].group = value;
                                setAutoSendSettingList([
                                  ...autoSendSettingList,
                                ]);
                              }}
                            />
                          </Td>
                        </Tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
            <div
              style={{
                width: "100%",
                height: 79,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 12,
              }}
            >
              <BasicBtn
                onClick={() => {
                  setCreateModalOpen({
                    setting: false,
                    autoSend: true,
                  });
                }}
              >
                저장하기
              </BasicBtn>
            </div>
          </MessageSmsContainer>
        </DetailPageLayout>
      </MainLayout>

      {/* 발송하기 모달창 */}
      {createModalOpen.setting && (
        <Modal
          type="alert"
          title="발송되었습니다"
          setModalOpen={setCreateModalOpen}
          onClick={() => {
            setCreateModalOpen({
              setting: false,
              autoSend: false,
            });
          }}
        />
      )}

      {/* 저장하기 모달창 */}
      {createModalOpen.autoSend && (
        <Modal
          type="alert"
          title="저장되었습니다"
          setModalOpen={setCreateModalOpen}
          onClick={() => {
            setCreateModalOpen({
              setting: false,
              autoSend: false,
            });
          }}
        />
      )}
    </>
  );
};

export default OperationMessageSms;

const TabWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 30px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 28px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;

const MessageSmsContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const MessageSmsItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 21px 0px;
`;

const MessageSmsItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
`;

const MessageSmsItemContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const SmsBoxContainer = styled.div.attrs((props) => {})`
  width: 509px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  background: #272829;
  box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.12);
  padding: 12px 0px;
`;

const SmsBoxHeaderContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 43px;
  padding: 0px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

const SmsBoxHeaderWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SmsBoxHeaderTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const SmsBoxHeaderMore = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
  cursor: pointer;
`;

const SmsBoxContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SmsBoxContentWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  gap: 3px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const SmsBoxContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.3%;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
